export const intranetConstants = {
  FETCH_CLIENTS_SUCCESS: 'FETCH_CLIENTS_SUCCESS',
  FETCH_CLIENTS_LOADING: 'FETCH_CLIENTS_LOADING',
  FETCH_CLIENTS_ERROR: 'FETCH_CLIENTS_ERROR',

  SAVING_NEW_CLIENT: 'SAVING_NEW_CLIENT',
  SAVING_NEW_CLIENT_SUCCESS: 'SAVING_NEW_CLIENT_SUCCESS',
  SAVING_NEW_CLIENT_ERROR: 'SAVING_NEW_CLIENT_ERROR',

  FETCH_SUPPLIER_SUCCESS: 'FETCH_SUPPLIER_SUCCESS',

  FETCH_SUPPLIER_LOADING: 'FETCH_SUPPLIER_LOADING',
  FETCH_SUPPLIER_ERROR: 'FETCH_SUPPLIER_ERROR',

  SAVING_NEW_SUPPLIER: 'SAVING_NEW_SUPPLIER',
  SAVING_NEW_SUPPLIER_SUCCESS: 'SAVING_NEW_SUPPLIER_SUCCESS',
  SAVING_NEW_SUPPLIER_ERROR: 'SAVING_NEW_SUPPLIER_ERROR',

  UPDATE_SUPPLIER: 'UPDATE_SUPPLIER',
  UPDATE_SUPPLIER_SUCCESS: 'UPDATE_SUPPLIER_SUCCESS',
  UPDATE_SUPPLIER_ERROR: 'UPDATE_SUPPLIER_ERROR',

  DELETE_SUPPLIER: 'DELETE_SUPPLIER',
  DELETE_SUPPLIER_SUCCESS: 'DELETE_SUPPLIER_SUCCESS',
  DELETE_SUPPLIER_ERROR: 'DELETE_SUPPLIER_ERROR',

  FETCH_ORGANIZATION_SUCCESS: 'FETCH_ORGANIZATION_SUCCESS',
  FETCH_ORGANIZATION_LOADING: 'FETCH_ORGANIZATION_LOADING',
  FETCH_ORGANIZATION_ERROR: 'FETCH_ORGANIZATION_ERROR',

  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_LOADING: 'FETCH_USERS_LOADING',
  FETCH_USERS_ERROR: 'FETCH_USERS_ERROR',
} as const
